module.exports = { id: "frame-unisex", url: "/build/app/img/symbols.svg#frame-unisex", viewBox: "", toString: function() { return this.url; } };